import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Sheet } from './Sheet.vue'
export { default as SheetClose } from './SheetClose.vue'
export { default as SheetContent } from './SheetContent.vue'
export { default as SheetDescription } from './SheetDescription.vue'
export { default as SheetFooter } from './SheetFooter.vue'
export { default as SheetHeader } from './SheetHeader.vue'
export { default as SheetTitle } from './SheetTitle.vue'
export { default as SheetTrigger } from './SheetTrigger.vue'

/*
 * (derived) A bottom/top sheet reads as sliding out from that edge, so it gets
 * a rounded leading corner pair — the canonical Dialog's radius (`ds-xl`).
 * A left/right sheet reads as a full-height panel, so it stays flush like
 * shadcn's own base (no canonical spec exists for either shape).
 */
export const sheetVariants = cva(
  [
    'fixed z-50 gap-4 font-ds bg-card text-card-foreground shadow-ds-xl',
    'transition ease-ds-standard duration-ds-normal',
    'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
  ].join(' '),
  {
    variants: {
      side: {
        top: 'inset-x-0 top-0 p-6 border-b border-border rounded-b-ds-xl data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top',
        bottom:
          'inset-x-0 bottom-0 p-6 border-t border-border rounded-t-ds-xl data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom',
        left: 'inset-y-0 left-0 h-full w-3/4 p-6 border-r border-border data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm',
        right:
          'inset-y-0 right-0 h-full w-3/4 p-6 border-l border-border data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm',
      },
    },
    defaultVariants: {
      side: 'right',
    },
  },
)

export type SheetVariants = VariantProps<typeof sheetVariants>
